import { SET_ACCOUNT_ID_PARAM } from './constants'

export default accountIdParam => dispatch => {
    dispatch({
        type: SET_ACCOUNT_ID_PARAM,
        payload: accountIdParam,
    })
}
